export default __webpack_public_path__ + "static/media/hot.7de55c1f.jpg";